import { useSelector } from "react-redux";
import Authenticated from "./Authenticated";
import Unauthenticated from "./Unauthenticated";

function Home() {
  const { user } = useSelector((state) => state.user);
  console.log("Home")
  return <div className="z-0">{user ? <Authenticated /> : <Unauthenticated />}</div>;
}

export default Home;
